import { render, staticRenderFns } from "./MatchProject.vue?vue&type=template&id=f6b31706&scoped=true"
import script from "./MatchProject.vue?vue&type=script&lang=js"
export * from "./MatchProject.vue?vue&type=script&lang=js"
import style0 from "./MatchProject.vue?vue&type=style&index=0&id=f6b31706&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b31706",
  null
  
)

export default component.exports